// Persistência do código do cliente ativo do módulo (localStorage) —
// compartilhado por Simulação e Ensaio desde 07/08/2026 (7ª rodada). Só o
// código é guardado — nome/detalhe são refetchados via API na reidratação, pra
// não deixar dado stale no storage. Sobrevive a reload (F5).
const KEY = 'feeFixo:clienteAtivoCodigo'

export const lerCodigoClienteAtivo = () => {
  try {
    return globalThis.localStorage.getItem(KEY) || null
  } catch (e) {
    // localStorage indisponível (modo privado/SSR) — segue só em memória.
    console.warn('[fee-fixo] localStorage indisponível ao ler cliente ativo:', e)
    return null
  }
}

export const salvarCodigoClienteAtivo = (codigo) => {
  try {
    if (codigo) {
      globalThis.localStorage.setItem(KEY, codigo)
    } else {
      globalThis.localStorage.removeItem(KEY)
    }
  } catch (e) {
    // localStorage indisponível (modo privado/SSR) — segue só em memória.
    console.warn(
      '[fee-fixo] localStorage indisponível ao salvar cliente ativo:',
      e
    )
    return null
  }
}
